import r from '../../../../../react/services/Replacement';
import ButtonContainer from '../../../../components/ButtonContainer';
import LinkButton from '../../../../components/LinkButton';

const DefaultObjectiveCycleSettings = () => {
    return (
        <>
            <h2>Default {r('objective.singular.big')} Cycle Settings</h2>
            <ButtonContainer align="left">
                <LinkButton href="/app/admin/objective/categories">
                    Manage Default {r('objective.category.plural.big')}
                </LinkButton>
                <LinkButton href="/app/admin/objective/ratings">
                    Manage Default {r('objective.singular.big')} Ratings
                </LinkButton>
            </ButtonContainer>
        </>
    );
};

export default DefaultObjectiveCycleSettings;
